@if (!mobile) {
  <div class="group-label">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
  <div class="group-options">
    @for (item of model; track item.key) {
      <ui-checkbox
        [checked]="item[checkedField]"
        [disabled]="item['disabled']"
        (change)="checkboxChange(item, $event)"
        >{{ item[labelField] }}</ui-checkbox
        >
      }
    </div>
  }
  @if (mobile) {
    <ui-dropdown
      [multi]="true"
      [model]="model"
      [valueField]="keyField"
      [labelField]="labelField"
      (change)="emitChanges()"
      >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ui-dropdown>
  }

  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
